module.exports = __webpack_public_path__ + "static/img/博士_2023_王启凡_1316606229@qq.com.013eea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/members/博士_2023_王启凡_1316606229@qq.com.jpg
// module id = QFal
// module chunks = 6